/**
 * ModalSkeleton — Suspense fallback Océanne (cream + terracotta).
 *
 * Affiché pendant le chargement lazy d'un contenu modal/page (Carnet, Colophon,
 * Lexique). Spinner terracotta sur fond transparent (hérite cream du parent).
 *
 * A11y :
 *  - role="status" + aria-live="polite" + aria-busy="true" → annonce loader
 *    aux lecteurs d'écran sans interrompre.
 *  - Tailwind v4 + motion-reduce (respect prefers-reduced-motion).
 *
 * Theme (locked via OKLCH inline pour rendre tokens indépendants d'un
 * styles.css partiellement chargé) :
 *  - Primary terracotta : oklch(0.62 0.135 38)  → #C96546
 *  - Foreground warm slate : oklch(0.32 0.011 280)
 */
export function ModalSkeleton() {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className="flex min-h-[280px] flex-col items-center justify-center gap-5 p-10"
    >
      <div
        aria-hidden="true"
        className="h-11 w-11 animate-spin rounded-full border-[3px] border-[oklch(0.62_0.135_38)]/15 border-t-[oklch(0.62_0.135_38)] motion-reduce:animate-none"
      />
      <p className="font-sans text-sm tracking-wide text-[oklch(0.32_0.011_280)]/70">
        Chargement…
      </p>
    </div>
  );
}
